import _ from 'underscore';

const i18nTimezoneMap = {
  TimezoneId_1: _TL_('(GMT+13:00) Nuku\'alofa'),
  TimezoneId_2: _TL_('(GMT+12:00) Fiji, Kamchatka, Marshall Is.'),
  TimezoneId_3: _TL_('(GMT+12:00) Auckland, Wellington'),
  TimezoneId_4: _TL_('(GMT+11:00) Magadan, Solomon Is., New Caledonia'),
  TimezoneId_5: _TL_('(GMT+10:00) Vladivostok'),
  TimezoneId_6: _TL_('(GMT+10:00) Hobart'),
  TimezoneId_7: _TL_('(GMT+10:00) Guam, Port Moresby'),
  TimezoneId_8: _TL_('(GMT+10:00) Canberra, Melbourne, Sydney'),
  TimezoneId_9: _TL_('(GMT+10:00) Brisbane'),
  TimezoneId_10: _TL_('(GMT+09:30) Darwin'),
  TimezoneId_11: _TL_('(GMT+09:30) Adelaide'),
  TimezoneId_12: _TL_('(GMT+09:00) Yakutsk'),
  TimezoneId_13: _TL_('(GMT+09:00) Seoul'),
  TimezoneId_14: _TL_('(GMT+09:00) Osaka, Sapporo, Tokyo'),
  TimezoneId_15: _TL_('(GMT+08:00) Taipei'),
  TimezoneId_16: _TL_('(GMT+08:00) Perth'),
  TimezoneId_17: _TL_('(GMT+08:00) Kuala Lumpur, Singapore'),
  TimezoneId_18: _TL_('(GMT+08:00) Irkutsk, Ulaan Bataar'),
  TimezoneId_19: _TL_('(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi'),
  TimezoneId_20: _TL_('(GMT+07:00) Krasnoyarsk'),
  TimezoneId_21: _TL_('(GMT+07:00) Bangkok, Hanoi, Jakarta'),
  TimezoneId_22: _TL_('(GMT+06:30) Yangon'),
  TimezoneId_23: _TL_('(GMT+06:00) Sri Jayawardenepura'),
  TimezoneId_24: _TL_('(GMT+06:00) Nur Sultan, Dhaka'),
  TimezoneId_25: _TL_('(GMT+06:00) Almaty, Novosibirsk'),
  TimezoneId_26: _TL_('(GMT+05:45) Kathmandu'),
  TimezoneId_27: _TL_('(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi'),
  TimezoneId_28: _TL_('(GMT+05:00) Islamabad, Karachi, Tashkent'),
  TimezoneId_29: _TL_('(GMT+05:00) Ekaterinburg'),
  TimezoneId_30: _TL_('(GMT+04:30) Kabul'),
  TimezoneId_31: _TL_('(GMT+04:00) Baku, Tbilisi, Yerevan'),
  TimezoneId_32: _TL_('(GMT+04:00) Abu Dhabi, Muscat'),
  TimezoneId_33: _TL_('(GMT+03:30) Tehran'),
  TimezoneId_34: _TL_('(GMT+03:00) Nairobi'),
  TimezoneId_35: _TL_('(GMT+03:00) Moscow, St. Petersburg, Volgograd'),
  TimezoneId_36: _TL_('(GMT+03:00) Kuwait, Riyadh'),
  TimezoneId_37: _TL_('(GMT+03:00) Baghdad'),
  TimezoneId_38: _TL_('(GMT+02:00) Jerusalem'),
  TimezoneId_39: _TL_('(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'),
  TimezoneId_40: _TL_('(GMT+02:00) Harare, Pretoria'),
  TimezoneId_41: _TL_('(GMT+02:00) Cairo'),
  TimezoneId_42: _TL_('(GMT+02:00) Bucharest'),
  TimezoneId_43: _TL_('(GMT+02:00) Athens, Istanbul, Minsk'),
  TimezoneId_44: _TL_('(GMT+01:00) West Central Africa'),
  TimezoneId_45: _TL_('(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb'),
  TimezoneId_46: _TL_('(GMT+01:00) Brussels, Copenhagen, Madrid, Paris'),
  TimezoneId_47: _TL_('(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague'),
  TimezoneId_48: _TL_('(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'),
  TimezoneId_49: _TL_('(GMT) Casablanca, Monrovia'),
  TimezoneId_50: _TL_('(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London'),
  TimezoneId_51: _TL_('(GMT-01:00) Azores'),
  TimezoneId_52: _TL_('(GMT-01:00) Cabo Verde'),
  TimezoneId_53: _TL_('(GMT-02:00) Mid-Atlantic'),
  TimezoneId_54: _TL_('(GMT-03:00) Brasilia'),
  TimezoneId_55: _TL_('(GMT-03:00) Buenos Aires, Georgetown'),
  TimezoneId_56: _TL_('(GMT-03:00) Greenland'),
  TimezoneId_57: _TL_('(GMT-03:30) Newfoundland'),
  TimezoneId_58: _TL_('(GMT-04:00) Atlantic Time (Canada)'),
  TimezoneId_59: _TL_('(GMT-04:00) Caracas, La Paz'),
  TimezoneId_60: _TL_('(GMT-03:00) Santiago'),
  TimezoneId_61: _TL_('(GMT-05:00) Bogota, Lima, Quito'),
  TimezoneId_62: _TL_('(GMT-05:00) Eastern Time (U.S. & Canada)'),
  TimezoneId_63: _TL_('(GMT-05:00) Indiana (East)'),
  TimezoneId_64: _TL_('(GMT-06:00) Central America'),
  TimezoneId_65: _TL_('(GMT-06:00) Central Time (U.S. & Canada)'),
  TimezoneId_66: _TL_('(GMT-06:00) Guadalajara, Mexico City, Monterrey'),
  TimezoneId_67: _TL_('(GMT-06:00) Saskatchewan'),
  TimezoneId_68: _TL_('(GMT-07:00) Arizona'),
  TimezoneId_69: _TL_('(GMT-07:00) Chihuahua, La Paz, Mazatlan'),
  TimezoneId_70: _TL_('(GMT-07:00) Mountain Time (U.S. & Canada)'),
  TimezoneId_71: _TL_('(GMT-08:00) Pacific Time (U.S. & Canada); Tijuana'),
  TimezoneId_72: _TL_('(GMT-09:00) Alaska'),
  TimezoneId_73: _TL_('(GMT-10:00) Hawaii'),
  TimezoneId_74: _TL_('(GMT-11:00) Midway Island, Samoa'),
  TimezoneId_75: _TL_('(GMT-12:00) International Date Line West'),
};

// Consider to extract i18n string mapping to a seperate package
export function getTimezoneI18nString(timezoneId) {
  const id = _.isNumber(timezoneId) ? timezoneId : Number(timezoneId);
  if (id >= 1 && id <= 75) {
    return i18nTimezoneMap[`TimezoneId_${id}`];
  }

  return _TL_('Unknown');
}
